<template>
  <div>
    <nav class="bg-white shadow-md">
      <div class="max-w-4xl mx-auto px-4">
        <!-- Desktop and Mobile Header -->
        <div class="flex justify-between items-center h-16">
          <router-link 
            :to="auth.user.value ? '/' : '/login'" 
            class="app-title"
          >
          <span class="material-icons title-icon">content_paste_search</span>
            InspectList
          </router-link>
          
          <!-- Only show menu button if authenticated -->
          <button 
            v-if="auth.user.value"
            @click="isMenuOpen = !isMenuOpen" 
            class="md:hidden p-2 rounded-lg hover:bg-gray-100"
          >
            <span class="material-icons">{{ isMenuOpen ? 'close' : 'menu' }}</span>
          </button>

          <!-- Desktop Navigation - Only show if authenticated -->
          <div v-if="auth.user.value" class="hidden md:flex items-center gap-4">
            <router-link to="/in-progress" class="nav-link">
              <span class="material-icons">pending</span>
              En Progreso
            </router-link>
            <router-link to="/pdfs" class="nav-link">
              <span class="material-icons">description</span>
              PDFs
            </router-link>
            <router-link to="/settings" class="nav-link">
              <span class="material-icons">settings</span>
              Configuración
            </router-link>
            <button @click="handleLogout" class="nav-link text-red-600">
              <span class="material-icons">logout</span>
              
            </button>
          </div>
        </div>

        <!-- Mobile Navigation - Only show if authenticated -->
        <div 
          v-if="isMenuOpen && auth.user.value" 
          class="md:hidden py-4 space-y-2 border-t"
        >
          <router-link 
            to="/" 
            class="nav-link-mobile"
            @click="isMenuOpen = false"
          >
            <span class="material-icons">list</span>
            Todas las Listas
          </router-link>
          <router-link 
            to="/in-progress" 
            class="nav-link-mobile"
            @click="isMenuOpen = false"
          >
            <span class="material-icons">pending</span>
            En Progreso
          </router-link>
          <router-link 
            to="/pdfs" 
            class="nav-link-mobile"
            @click="isMenuOpen = false"
          >
            <span class="material-icons">description</span>
            PDFs
          </router-link>
          <router-link 
            to="/settings" 
            class="nav-link-mobile"
            @click="isMenuOpen = false"
          >
            <span class="material-icons">settings</span>
            Configuración
          </router-link>
          <button 
            @click="mobileLogout" 
            class="nav-link-mobile text-red-600 w-full text-left"
          >
            <span class="material-icons">logout</span>
            Cerrar Sesión
          </button>
        </div>
      </div>
    </nav>
    <router-view />
    <PWAUpdateNotification />
  </div>
</template>

<script>
import { ref } from 'vue';
import { useAuth } from './firebase/auth';
import { useRouter } from 'vue-router';
import PWAUpdateNotification from './components/PWAUpdateNotification.vue';

export default {
  components: {
  PWAUpdateNotification
},
  name: 'App',
  setup() {
    const auth = useAuth();
    const router = useRouter();
    const isMenuOpen = ref(false);

    const handleLogout = async () => {
      try {
        await auth.logout();
        router.push('/login');
      } catch (error) {
        console.error('Logout failed:', error);
      }
    };

    const mobileLogout = async () => {
      isMenuOpen.value = false;
      await handleLogout();
    };

    return {
      auth,
      handleLogout,
      mobileLogout,
      isMenuOpen
    };
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap');

body {
  background-color: #f3f4f6;
  margin: 0;
  padding: 0;
  min-height: 100vh;
}

.nav-link {
  @apply text-gray-600 hover:text-blue-600 transition duration-200 flex items-center gap-1 px-3 py-2 rounded-lg hover:bg-gray-50;
}

.nav-link-mobile {
  @apply flex items-center gap-2 px-4 py-3 text-gray-600 hover:text-blue-600 hover:bg-gray-50 transition duration-200 rounded-lg;
}

.app-title {
  @apply text-xl font-bold whitespace-nowrap flex items-center gap-2;
  font-family: 'Poppins', sans-serif;
  background: linear-gradient(135deg, #1e40af, #1e3a8a);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -0.02em;
  padding: 0.5rem 0;
  transition: opacity 0.2s ease;
}

.title-icon {
  font-size: 1.75rem;
  margin-right: 0.25rem;
}

.app-title:hover {
  opacity: 0.85;
}
</style>